<template>
   <div>
    <div class="transaction-explorer mt-14 mb-14">
      <div class="mb-[10px]">
        <Paragraph class="text-blue-dark font-jost-regular text-[25px]" text="Proxy Funding Account" />
        <div class="flex gap-[20px] max-w-max relative w-auto">
          <p class="text-blue-light break-all font-jost-regular w-full text-blue-light text-left" style="font-size: 25px">
            {{ publicAddress }}
            <span class="inline-block cursor-pointer" title="Copy hash">
              <CopyIcon :isActive="checkIfIsEqual(publicAddress)" @click="copy(publicAddress)" title="Copy hash"
                class="h-[33px] ml-2 inline-block cursor-pointer" />
            </span>
          </p>
        </div>
      </div>

      <section class="t-results justify-between text-lg mt-5 mt-[105px] flex">
        <div>
          <Paragraph class="font-jost-regular text-blue-dark text-[25px] leading-[30px] mb-[11px]" text="Overview" />

          <div v-if="loaders.accountDetails"
            class="overview__section bg-white rounded-[9px] flex justify-center w-full mt-[30px] w-[676px] h-[250px] items-center">
            <Loader color="#64748B" width="30px" height="30px" />
          </div>
          <section v-else class="overview__section w-[676px] flex flex-wrap gap-[100px]">
            <div v-if="!loaders.accountDetails && account && Object.keys(account).length"
              class="t-results-body bg-white w-full">
              <div>
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Admin User
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ account.adminUser }}
                    </span>
                  </div>
                </div>
                <!-- <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    COIN Balance
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ account.balance }} GEEQ
                    </span>
                  </div>
                </div> -->
                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Chain Number
                  </div>
                  <div class="col px-2.5">
                    #{{ account.chainNumber }}
                  </div>
                </div>
                <!-- <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Total Transactions
                  </div>
                  <div class="col px-2.5">
                    <div class="flex gap-[5px] items-center">
                      <img src="/images/icons/sent-txs.png" />
                      <span class="font-jost-bold text-blue-dark text-[18px] leading-[26px]">
                        {{ account.sentTransactions }}
                      </span>

                      <img src="/images/icons/received-txs.png" />
                      <span class="font-jost-bold text-blue-dark text-[18px] leading-[26px]">
                        {{ account.receiveTransactions }}
                      </span>
                    </div>
                  </div>
                </div> -->

                <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Nonce
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ account.nonce || 'N/A' }}
                    </span>
                  </div>
                </div>

                <!-- <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Account Number
                  </div>
                  <div class="col font-jost-regular px-2.5 text-blue-dark">
                    <span class="block text-ellipsis text-[16px]">
                      {{ account.accountNumber || 'N/A' }}
                    </span>
                  </div>
                </div> -->
                <!-- <div
                  class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-blue-light flex items-baseline">
                  <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
                    Created At
                  </div>

                  <div class="font-jost-regular px-2.5 text-blue-dark">
                    <router-link v-if="account && account.blockNumber" class="block flex relative cursor-pointer text-blue-light"
                      :to="{ name: 'block', params: { chainNumber: account.chainNumber || $route.params.chainNumber || $route.params.chain, blockNumber: account.blockNumber } }">
                      Block #{{ account.blockNumber }}
                    </router-link>
                    {{ getTxCreationDateUtc() }} UTC
                  </div>
                </div> -->
              </div>
            </div>
            <Paragraph text="We couldn't find any results.." class="text-blue-dark text-lg mt-5 float-left" v-else />
          </section>
        </div>
        <OwnedNftsPanel :account-address="publicAddress" :chain-number="chainNumber" />
      </section>
      <div>
        <Paragraph class="font-inter-regular text-[#2A4067] text-[25px] leading-[30px] mt-[82px] mb-[10px]"
          text="Transactions" />
        <div v-if="loaders.transactions" class="flex items-center justify-center py-6">
          <Loader color="#64748B" width="30px" height="30px" />
        </div>
        <template v-else>
          <SearchableTable
            :transactions="proxyFundingTransactions || []"
            :copied="copied"
            :initialFilters="searchableTableInitialFilters"
            :accountAddress="publicAddress"
            @copied="handleCopied"
            @filtersChanged="handleFiltersChanged"
          />
          <div class="flex justify-end px-[25px]">
            <pagination-component :items="proxyFundingTransactions.total || 0" :initialPage="getInitialPage()"
              @changePage="setFoundResult" class="float-left" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-json-pretty/lib/styles.css";

import api from '@/helpers/api';
import string from '@/helpers/string';
import CopyIcon from '@/components/svg/CopyIcon';
import Loader from '@/components/common/Loader.vue';

import Paragraph from "@/components/web/ParagraphComponent";
import SearchableTable from '@/components/common/SearchableTable.vue';
import OwnedNftsPanel from '@/components/web/OwnedNftsPanel.vue';

import { maxTableRows } from "@/utils/pagination";
import moment from 'moment';

export default {
  name: "ProxyFundingAccountComponent",
  components: {
    CopyIcon,
    Loader,
    Paragraph,
    SearchableTable,
    OwnedNftsPanel
  },
  props: {
    walletAddress: {
      required: true
    },
    publicAddress: {
      required: true
    },
  },
  computed: {
    chainNumber() {
      return this.$route.params.chainNumber || this.$route.params.chain;
    },
    routeName() {
      return this.$route.name
    },
    searchableTableInitialFilters() {
      return {
        from: this.publicAddress || '',
        to: this.publicAddress || '',
      };
    },
  },
  data: () => {
    return {
      proxyFundingTransactions: {
        meta: {},
        result: []
      },
      loaders: {
        accountDetails: true,
        transactions: false,
      },
      account: null,
      copied: '',
      initialPage: 1,
      pageSize: maxTableRows,
      transactionFilters: {
        from: '',
        to: '',
        type: [],
        blockMin: undefined,
        blockMax: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: [],
      },
      transactionRefHash: "",
      virtualFlag: false,
      showLine: true,
      lastPath: null,
      collapsedOnClickBrackets: true,
      currentScrollItem: 1,
      transactionData: {},
    }
  },
  created() {
    this.lastPath = this.$router.options.history.state.back;
    this.searchByAccPublicAddress(this.walletAddress);
    this.getAccountAllTransactons();
  },

  methods: {
    setCopied(hash) {
      this.copied = hash;
    },
    getShortenedText(str) {
      return string.getShortenHash(str)
    },
    buildTransactionParams(filterOverrides = {}, skip = 0) {
      const types = Array.isArray(filterOverrides.type)
        ? filterOverrides.type
        : (filterOverrides.type ? [filterOverrides.type] : []);

      const statuses = Array.isArray(filterOverrides.status)
        ? filterOverrides.status
        : (filterOverrides.status ? [filterOverrides.status] : []);

      const fromAddress = typeof filterOverrides.from === 'string' && filterOverrides.from.trim()
        ? filterOverrides.from.trim()
        : undefined;
      const toAddress = typeof filterOverrides.to === 'string' && filterOverrides.to.trim()
        ? filterOverrides.to.trim()
        : undefined;

      return {
        chainNumber: this.chainNumber ? parseInt(this.chainNumber, 10) : undefined,
        from: fromAddress,
        to: toAddress,
        type: types,
        minBlock: filterOverrides.blockMin ?? undefined,
        maxBlock: filterOverrides.blockMax ?? undefined,
        dateFrom: filterOverrides.dateFrom ?? undefined,
        dateTo: filterOverrides.dateTo ?? undefined,
        status: statuses,
        limit: maxTableRows,
        skip
      };
    },
    getAccountAllTransactons(filterOverrides = this.transactionFilters, skip = 0) {
      this.loaders.transactions = true;

      const params = this.buildTransactionParams(filterOverrides, skip);

      return api.getTransactionsByType(params)
        .then((res) => {
          this.proxyFundingTransactions = res.data;

          this.loaders.transactions = false;
        })
        .catch(() => {
          this.loaders.transactions = false;
        })
    },
    getTxCreationDateUtc() {
      const createdAt = this.account.createdAt;
      if (!createdAt) {
        return '';
      }
      return moment.utc(createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
    getItem(page) {
      this.getAccountAllTransactons(this.transactionFilters, (page - 1) * maxTableRows);
    },
    setFoundResult(data) {
      const page = Number(data?.page) > 0 ? Number(data.page) : 1;
      this.getItem(page);
    },
    getInitialPage() {
      let page = this.initialPage;
      if (this.proxyFundingTransactions.result && Object.keys(this.proxyFundingTransactions.result).length) {
        page = this.proxyFundingTransactions.meta ? this.proxyFundingTransactions.meta.skip / this.pageSize + 1 : this.initialPage;
      }
      return page;
    },
    handleCopied(copiedText) {
      this.copied = copiedText;
    },
    handleFiltersChanged(filterData) {
      const nextFilters = {
        from: typeof filterData.from === 'string' ? filterData.from : '',
        to: typeof filterData.to === 'string' ? filterData.to : '',
        type: Array.isArray(filterData.type)
          ? filterData.type
          : (filterData.type ? [filterData.type] : []),
        blockMin: filterData.blockMin ?? undefined,
        blockMax: filterData.blockMax ?? undefined,
        dateFrom: filterData.dateFrom ?? undefined,
        dateTo: filterData.dateTo ?? undefined,
        status: Array.isArray(filterData.status)
          ? filterData.status
          : (filterData.status ? [filterData.status] : []),
      };

      this.transactionFilters = nextFilters;
      this.getAccountAllTransactons(nextFilters, 0);
    },
    getTitle() {
      return this.routeName === "transaction" ? "AppCommitHash" : "RefHash"
    },
    goBack() {
      this.$router.push({ name: 'search-result' })
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    searchByAccPublicAddress() {
      this.loaders.accountDetails = true;

      return api.getProxyFundingAccountDetails(this.walletAddress, this.chainNumber)
        .then((res) => {
          const data = res.data;
          this.account = data;

          this.loaders.accountDetails = false;

        })
        .catch(() => {
          this.loaders.accountDetails = false;
        })
    },
  }
}
</script>

<style>
* {
  font-family: 'Jost-regular', sans-serif;
}

.transaction-explorer .vjs-value {
  color: #2699FB !important;
  font-size: 18px;
  line-height: 26px;
  font-family: 'Inter-Regular', monospace !important;
}

.transaction-explorer .vjs-tree {
  font-size: 18px;
  line-height: 26px;
  overflow-x: auto !important;
  white-space: nowrap;
}

.transaction-explorer .vjs-key {
  font-family: 'Inter-Regular', monospace !important;
}
</style>

<style scoped>
.col {
  width: 30%;
}

.t-results-body {
  padding: 15px 15px 10px 15px;
  border-radius: 9px 9px 9px 9px;
}

.t-results-body .row:first-child {
  border-top: unset;
}

.is-active {
  background-color: #D66339;
}

@media(max-width:1750px) {
  .t-results {
    gap: 20px;
  }
}

@media(max-width:1500px) {
  .overview__section {
    max-width: 570px;
  }
}

@media (max-width: 767px) {
  .main-container {
    padding: 20px 0px !important;
  }

  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 680px;
  }
}

@media (max-width: 715px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 600px;
  }
}

@media (max-width: 620px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 500px;
  }
}

@media (max-width: 520px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 400px;
  }
}

@media (max-width: 420px) {
  .overview__section {
    width: 100%;
    margin: auto;
    max-width: 100%;
  }
}

@media (max-width: 390px) {
  .overview__section {
    width: 320px;
  }
}
</style>
